<span *ngIf="itemList.length !== 0" class="topbar-badge">{{itemList.length}}</span>
